define(['jquery'],
	function($) {
	  $.fn.newsletterSignUp = function(options) {
		switch(options.environment){
		  case 'dev':
			var target = "https://servicesdev.garmin.com/emailPreferenceProcessServices/emailPreferences";
			break
		  case 'stage':
		  case 'test':
			var target = "https://servicestest.garmin.com/emailPreferenceProcessServices/emailPreferences";
			break
		  default:
			var target = "https://services.garmin.com/emailPreferenceProcessServices/emailPreferences";
		}
		var settings = $.extend({
		  locale : 'en-US',
		  target : target
		}, options);

		var validEmail = function(email) {
			return email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
		};

		// external DOM tree context
		var context = this;
		//caches jQuery calls
		var $form           = "form",
			$formTypeEmail  = "input[name*='email']",
			$jsEmailHeader  = ".email-message",
			$errorMessage   = ".email-error",
			$source         = "input[name*='source']",
			$inTheAirNewsletterSignUpButton	= ".inTheAirNewsletterSignUpButton";

		// prevent form submission
		$($form, context).on("submit", function() {
			return false;
		});

		// bind event handler for DOM elements
		$($formTypeEmail, context).on("click", function() {
			this.value = "";
			$($errorMessage).hide();
		});

		// binds event button's event handler
		$("button[type=submit]", context).on("click", function() {

			var email = $($formTypeEmail, context).val();

			// validate email input
			if(!validEmail(email)) {
				$($errorMessage).text("Please enter a valid email address.").show();
				return;
			}

			// converts form data to JSON object
			var data = {
				email : email,
				locale : settings.locale,
				preferences : [{
					category : $("input[name*='category']", context).val(),
					subcategory : $("input[name*='subcategory']", context).val(),
					source : $($source, context).val(),
					consentTypeId : $("input[name*='consentTypeId']", context).val(),
					version: $("input[name*='version']", context).val()
				}]
			};

			// AJAX REST service call
			$.ajax({
				type : "POST",
				url : settings.target,
				headers: {'x-garmin-client-id': $($source, context).val().toUpperCase()},
				data : JSON.stringify(data),
				contentType : "application/json; charset=utf-8",
				context : context
			}).done(function(data, status, jqXHR) {
				//shows the success message
				$($errorMessage).hide();
				$($inTheAirNewsletterSignUpButton).hide();
				var message = $($jsEmailHeader).attr("data-success");

				//the callback waits for the animation to show the update text
				animationCallback = function(){
					$($jsEmailHeader).text(message);
				}
				setTimeout(animationCallback, 500); //500 is half the length of the CSS animation
			}).fail(function() {
				$($errorMessage).text("Error submitting request.").show();
			});
		})
	  }
	}
);
